import React from 'react'
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { Provider } from 'react-redux';
import { createRoot } from "react-dom/client";
import './index.css';
import './scss/globals.scss';
import 'normalize.css';
import 'react-modern-drawer/dist/index.css';
import theme from './theme';
import { ThemeProvider } from 'theme-ui';
import { BrowserRouter } from 'react-router-dom';
import asyncConfigureStore from './store';

const root = document.getElementById('root');

// Asynchronously configure the Redux store and render the app
const initializeApp = async () => {
  const store = await asyncConfigureStore(); // Wait for store configuration

  const root = createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
    </React.StrictMode>
  );
};

initializeApp(); // Call the initialization function
